import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/About.vue')
    },
    {
      path: '/samples',
      name: 'samples',
      component: () => import('@/views/Samples.vue')
    },
    {
      path: '/samples/preview',
      name: 'samples-preview',
      component: () => import('@/views/SamplesPreview.vue')
    },
    {
      path: '/samples/:category',
      name: 'sample-category',
      component: () => import('@/views/samples/CategoryView.vue')
    },
    {
      path: '/samples/:category/:sample',
      name: 'sample-detail',
      component: () => import('@/views/samples/SampleDetailView.vue')
    },
    {
      path: '/tools',
      name: 'tools',
      component: () => import('@/views/Tools.vue')
    },
  ]
})

export default router